import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import classNames from "classnames";
import { useSelector } from "@jti/store";
import { ReferralPersonalCode as ReferralPersonalCodeLib, replaceStringPlaceholder, } from "@jti/ui";
import useLoggedUser from "../../helpers/hooks/useLoggedUser";
import { AccountActionButtons } from "../account-action-buttons/AccountActionButtons";
import styles from "./ReferralPersonalCode.module.scss";
export const ReferralPersonalCode = ({ topHeader, header, codeTitle, shareTitle, description, variant, referralPageVariant, items = [], infoTitle, backgroundimage, backgroundimagetablet, backgroundimagemobile, smallText, signInTitle, signInUrl, registerUrl, isInEditor, registerTitle, isInBuilder, withBottomCta = false, bottomCtaLabel = "", bottomCtaLink = "", }) => {
    const [isLogged] = useLoggedUser();
    const { code, isReferralOn } = useSelector((store) => store.loyaltyCore);
    const referralPageProps = referralPageVariant
        ? {
            showCta: !isLogged,
            ctaRow: (_jsx(AccountActionButtons, { signInTitle: signInTitle, signInUrl: signInUrl, registerUrl: registerUrl, registerTitle: registerTitle })),
        }
        : {};
    const classes = classNames(styles.wrapper, {
        [styles.withImageStyles]: variant === "withBackgroundImage",
        [styles.dashboardStyles]: variant === "dashboard",
        [styles.builderStyle]: isInBuilder,
    });
    const replaceUrlCode = (url, code, withStyles) => {
        return replaceStringPlaceholder(url, [
            {
                placeholder: "refferalCode",
                value: code,
            },
        ], withStyles);
    };
    const itemsUrlCodeConverted = useMemo(() => {
        if (items.length === 0 || !code)
            return [];
        return items.map((element) => ({
            ...element,
            url: replaceUrlCode(element.url, code, false),
        }));
    }, [items, code]);
    if (((!isLogged && !referralPageVariant) || !isReferralOn) && !isInEditor)
        return null;
    return (_jsx(ReferralPersonalCodeLib, { code: code, codeTitle: codeTitle, shareTitle: shareTitle, backgroundimage: backgroundimage, backgroundimagetablet: backgroundimagetablet, backgroundimagemobile: backgroundimagemobile, variant: variant, referralPageVariant: referralPageVariant, infoTitle: infoTitle, topHeader: topHeader, description: description, header: header, smallText: smallText, items: itemsUrlCodeConverted, className: classes, withBottomCta: withBottomCta, bottomCtaLabel: bottomCtaLabel, bottomCtaLink: bottomCtaLink, ...referralPageProps }));
};
//# sourceMappingURL=ReferralPersonalCode.js.map